import { render } from "./ModalContainer.vue?vue&type=template&id=24825a83&scoped=true"
import script from "./ModalContainer.vue?vue&type=script&lang=js"
export * from "./ModalContainer.vue?vue&type=script&lang=js"

import "./ModalContainer.vue?vue&type=style&index=0&id=24825a83&lang=scss&scoped=true"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24825a83"]])

export default __exports__